import { numberFormatToPtBr, roundDecimalNumberToInteger } from '@/utils';

const formattedTooltip = (coordinate) => {
  const formattedFans = numberFormatToPtBr(Number(coordinate.y));
  const formattedPercent = 'percent' in coordinate.point ? `(${roundDecimalNumberToInteger(coordinate.point.percent)}%)` : '';

  return `
  <div class="tooltip-pie">
    <div class="tooltip-pie__header">
      <div class="tooltip-pie__point" style="background: ${coordinate.color};"></div>
      <div class="tooltip-pie__name">${coordinate.series.name}</div>
    </div>

    <div class="tooltip-pie__bottom">
      <span class="tooltip-pie__fans">${formattedFans} ${formattedPercent}</span>
    </div>
  </div>     
  `;
};

export default formattedTooltip;
